import React, { useEffect, useState } from 'react';
import { useParams, Link } from 'react-router-dom';
import DOMPurify from 'dompurify';
import Navbar from './Navbar';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import CircularProgress from '@mui/material/CircularProgress';
import Button from '@mui/material/Button';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ConnectionFinder from '../api/ConnectionFinder';

const SinglePost = () => {
    const { slug } = useParams();
    const [post, setPost] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(false);

    useEffect(() => {
        ConnectionFinder.get(`/posts/${slug}`)
            .then(res => {
                setPost(res.data);
                setLoading(false);
            })
            .catch(err => {
                console.error(err);
                setError(true);
                setLoading(false);
            });
    }, [slug]);

    return (
        <div style={{ width: '100%', minHeight: 'calc(100vh - 202px)' }}>
            <Navbar />
            <Box sx={{ 
                backgroundColor: '#f9fafb', 
                py: 2, 
                px: { xs: 2, sm: 4, md: 6 },
                borderBottom: '1px solid #e5e7eb'
            }}>
                <Button 
                    component={Link} 
                    to="/blog" 
                    startIcon={<ArrowBackIcon />}
                    sx={{ 
                        color: '#ff0f64', 
                        fontWeight: 'bold', 
                        textTransform: 'none',
                        '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)'
                        }
                    }}
                >
                    Torna agli articoli
                </Button>
            </Box>
            <Box sx={{ backgroundColor: '#f9fafb', minHeight: 'calc(100vh - 302px)', py: { xs: 4, md: 8 }, px: { xs: 2, sm: 4 }, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
                
                {loading ? (
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 5 }}>
                        <CircularProgress sx={{ color: '#ff0f64' }} />
                    </Box>
                ) : error ? (
                    <Box sx={{ textAlign: 'center', mt: 5 }}>
                        <Typography variant="h4" sx={{ color: 'red', mb: 2 }}>Post non trovato</Typography>
                        <Button component={Link} to="/blog" sx={{ color: '#ff0f64', fontWeight: 'bold' }}>Riprova</Button>
                    </Box>
                ) : (
                    <Box sx={{ maxWidth: '900px', width: '100%', backgroundColor: 'white', p: { xs: 3, md: 6 }, borderRadius: '16px', boxShadow: '0 8px 32px rgba(0,0,0,0.08)' }}>
                        {post.cover_image && (
                            <Box component="img" src={post.cover_image} alt={post.title} sx={{ width: '100%', maxHeight: '500px', objectFit: 'cover', borderRadius: '12px', mb: 5, boxShadow: '0 4px 20px rgba(0,0,0,0.1)' }} />
                        )}
                        
                        <Typography variant="overline" sx={{ color: '#ff0f64', fontWeight: 'bold', letterSpacing: 1.5, mb: 1, display: 'block', textAlign: 'center' }}>
                            {new Date(post.published_at || post.created_at).toLocaleDateString('it-IT', { year: 'numeric', month: 'long', day: 'numeric' })}
                        </Typography>
                        
                        <Typography variant="h2" sx={{ fontWeight: '800', mb: 4, color: '#2c3e50', textAlign: 'center', fontSize: { xs: '2.5rem', md: '3.5rem' }, lineHeight: 1.2 }}>
                            {post.title}
                        </Typography>
                        
                        <Box sx={{ width: '60px', height: '4px', backgroundColor: '#ff0f64', mx: 'auto', mb: 5, borderRadius: '2px' }} />

                        <Box 
                            sx={{ 
                                color: '#4a4a4a', lineHeight: 1.9, fontSize: '1.15rem', 
                                '& img': { maxWidth: '100%', height: 'auto', borderRadius: '8px', my: 3, boxShadow: '0 2px 12px rgba(0,0,0,0.1)' },
                                '& h1, & h2, & h3, & h4': { color: '#2c3e50', fontWeight: 700, mt: 5, mb: 2 },
                                '& p': { mb: 3 },
                                '& a': { color: '#ff0f64', textDecoration: 'none', fontWeight: 600, '&:hover': { textDecoration: 'underline' } },
                                '& blockquote': { borderLeft: '4px solid #ff0f64', pl: 3, ml: 0, my: 4, fontStyle: 'italic', color: '#7B7D7D', backgroundColor: '#fafafa', py: 2, borderRadius: '0 8px 8px 0' },
                                '& ul, & ol': { mb: 3, pl: 3 },
                                '& li': { mb: 1 }
                            }}
                            dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(post.content) }} 
                        />
                        <Box sx={{ mt: 8, display: 'flex', justifyContent: 'center' }}>
                            <Button component={Link} to="/blog" variant="outlined" sx={{ borderWidth: '2px', borderRadius: '30px', px: 4, py: 1.5, borderColor: '#ff0f64', color: '#ff0f64', fontWeight: 'bold', fontSize: '1.1rem', '&:hover': { backgroundColor: 'rgba(255, 15, 100, 0.08)', borderColor: '#ff0f64', borderWidth: '2px' } }}>
                                ← Torna agli articoli
                            </Button>
                        </Box>
                    </Box>
                )}
            </Box>
        </div>
    );
};

export default SinglePost;